module.exports = __webpack_public_path__ + "img/diagram.2783c565.png";